import { Component, inject, OnInit, signal } from "@angular/core";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AuthService } from "../../../../core/auth/auth.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "app-otp-login",
    templateUrl: "./otp-login.component.html",
    imports: [ReactiveFormsModule, TranslatePipe]
})
export class OtpLoginComponent implements OnInit {
    private readonly authService = inject(AuthService);

    private readonly fb = inject(FormBuilder);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    
    protected otpStep = signal<'emailInput' | 'enterOtp'>('emailInput');
    protected isInSubmit = signal(false);
    protected showError = signal(false);

    protected emailForm = this.fb.group({
        email: ['', [Validators.required, Validators.email]]
    });

    protected otpForm = this.fb.group({
        otp: ['', [Validators.required]]
    });


    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            if(params['otp']) {
                this.otpStep.set('enterOtp');
                this.otpForm.patchValue({ otp: params['otp'] });
                this.onSubmit();
            }
        });
    }

    protected onSubmit() {
        if(this.otpStep() === 'emailInput') {
            this.sendOtp();
        } else if (this.otpStep() === 'enterOtp') {
            this.verifyOtp();
        }
    }


    private sendOtp() {
        if (this.emailForm.invalid) {
            this.emailForm.markAllAsTouched();
            return;
        }

        const email = this.emailForm.value.email!;
        this.isInSubmit.set(true);
        this.showError.set(false);

        this.authService.generateOtp(email).subscribe({
            next: () => {
                this.isInSubmit.set(false);
                this.otpStep.set('enterOtp');
            },
            error: (_) => {
                this.isInSubmit.set(false);
                this.showError.set(true);
            }
        });
    }

    private verifyOtp() {
        if (this.otpForm.invalid) {
            this.otpForm.markAllAsTouched();
            return;
        }

        this.isInSubmit.set(true);
        const otp = this.otpForm.value.otp!;

        this.authService.loginWithOtpToken(otp).subscribe({
            next: () => {
                this.isInSubmit.set(false);
                this.router.navigate(['/dashboard']);
            },
            error: (_) => {
                this.isInSubmit.set(false);
                this.showError.set(true);
            }
        });

    }
}